export default __webpack_public_path__ + "812becf46161ff2917cb74b46859e406.png";